export { Label, type LabelType } from './label';
